import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class PriceEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadPrice(token, ID) {
		

		
		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "price/v1/getcodaverage/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editPrice(token, price: any) {
		

		
		
		
		
		
		
		

		return this.http
		.put(this.apiUrl + "price/v1/updateaverage", JSON.stringify(price), JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/price/service/price-edit/price-edit.service.ts